import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { AntSelect } from "@/CommonElements/AntSelect";
import { useLocalizedText } from "@/utils/hooks/useLocalizedText";
import { useGroupsQuery } from "@/services/groups";
import { PLATFORMS } from "@/utils/constants";

/**
 * Group options for the Users list filter modal — data from GET /api/v1/groups (system_id = user management).
 */
export const UsersListGroupFilterSelect = ({
  value,
  onChange,
  placeholder,
  allowClear = true,
}) => {
  const { t } = useTranslation();
  const { getLocalizedText } = useLocalizedText();

  const { data: groupsRes, isLoading } = useGroupsQuery({
    system_id: PLATFORMS.user_management.system_id,
  });

  const options = useMemo(() => {
    const rows = groupsRes?.data?.data;
    if (!Array.isArray(rows)) return [];
    return rows.map((g) => ({
      value: g.id,
      label: getLocalizedText(g.name_ar, g.name_en) || g.name || String(g.id),
    }));
  }, [groupsRes, getLocalizedText]);

  return (
    <AntSelect
      loading={isLoading}
      showSearch
      allowClear={allowClear}
      placeholder={placeholder || t("GROUP")}
      value={value ?? undefined}
      onChange={onChange}
      options={options}
      optionFilterProp="label"
      className="w-100"
    />
  );
};
